<div class="dr-details" id="print-root">
  <section class="dr-hero no-print">
    <div class="dr-hero__glow"></div>
    <div class="dr-hero__content">
      <div class="dr-hero__summary">
        <p class="dr-hero__eyebrow">Diagnostic Dossier</p>
        <h1>{{ reportTitle(report) }}</h1>
        <p class="dr-hero__meta-line">
          @if (report && report.issued) {
          <span>Issued {{ report && report.issued ? (report.issued | date:'medium') : '—' }}</span>
          }
          @if (report && report.issued && report.subject) {
          <span class="dot">•</span>
          }
          @if (report && report.subject) {
          <span>{{ patientDisplay(report) }}</span>
          }
        </p>
      </div>
      <div class="dr-hero__actions">
        <button mat-button (click)="print()"
         class="rounded-icon-wrapper"
         [disabled]="loading || !report">
          <mat-icon aria-hidden="true"
          style="margin-right: 0px;"
          >print</mat-icon>
        
        </button>
        @if (dialogRef) {
        <button mat-button (click)="close()" 
        
        class="rounded-icon-wrapper">
            <mat-icon aria-hidden="true"
            style="margin-right: 0px;"
            >close</mat-icon>
        </button>
        }
      </div>
    </div>
    <!-- <div class="dr-hero__stats">
      <div class="dr-hero__stat">
        <span class="label">Status</span>
        <mat-chip-set>
          <mat-chip>{{ statusLabel(report ? report.status : null) }}</mat-chip>
        </mat-chip-set>
      </div>
      <div class="dr-hero__stat">
        <span class="label">Performer</span>
        <div class="value">
          @if (report && report.performer && report.performer.length) {
          <span>{{ performerDisplay(report) }}</span>
          } @else {
          <span>—</span>
          }
        </div>
      </div>
      <div class="dr-hero__stat">
        <span class="label">Interpreter</span>
        <div class="value">
          @if (report && report.resultsInterpreter && report.resultsInterpreter.length) {
          <span>{{ interpreterDisplay(report) }}</span>
          } @else {
          <span>—</span>
          }
        </div>
      </div>
    </div> -->
  </section>

  @if (loading) {
  <div class="dr-details__loading">
    <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
    <div>Loading report…</div>
  </div>
  }

  @if (!loading && loadError) {
  <mat-card>
    <mat-card-title>Couldn’t load report</mat-card-title>
    <mat-card-content>
      <div class="muted">{{ loadError }}</div>
    </mat-card-content>
  </mat-card>
  }

  @if (!loading && report) {
  <div class="dr-layout">
    <section class="dr-main">
      <mat-card class="dr-panel">
        <mat-card-subtitle>Clinical snapshot</mat-card-subtitle>
        <mat-card-title>Summary</mat-card-title>
        <mat-card-content style="padding: 0px !important;">
          <div class="kv">
            <div class="kv__row">
              <div class="kv__k">Issued</div>
              <div class="kv__v">{{ report && report.issued ? (report.issued | date:'fullDate') : '—' }}</div>
            </div>
            <div class="kv__row">
              <div class="kv__k">Patient</div>
              <div class="kv__v">{{ patientDisplay(report) }}</div>
            </div>
            @if (report && report.performer && report.performer.length) {
            <div class="kv__row">
              <div class="kv__k">Performer</div>
              <div class="kv__v">{{ performerDisplay(report) }}
              </div>
            </div>
            }
            @if (report && report.resultsInterpreter && report.resultsInterpreter.length) {
            <div class="kv__row">
              <div class="kv__k">Interpreter</div>
              <div class="kv__v">{{ interpreterDisplay(report) }}
              </div>
            </div>
            }
            @if (report && report.conclusion) {
            <div class="kv__row">
              <div class="kv__k">Conclusion</div>
              <div class="kv__v prewrap">{{ report && report.conclusion ? report.conclusion : '—' }}</div>
            </div>
            }
            @if (report && report.conclusionCode && report.conclusionCode.length > 0) {
            <div class="kv__row">
              <div class="kv__k">Conclusion Codes</div>
              <div class="kv__v">
                <mat-chip-set>
                  @for (c of report.conclusionCode; track $index) {
                  <mat-chip>{{ c.text ?? c.coding?.[0]?.display ?? c.coding?.[0]?.code ?? '—' }}</mat-chip>
                  }
                </mat-chip-set>
              </div>
            </div>
            }
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="dr-panel">
        <mat-card-subtitle>Observations</mat-card-subtitle>
        <mat-card-title>Results</mat-card-title>
        <mat-card-content>
          @if (observations.length === 0) {
          <div class="muted">No Observation results linked.</div>
          } @else {
          <div class="table-wrap fade-in">
            <table mat-table [dataSource]="observations" class="mat-elevation-z0">
              <ng-container matColumnDef="test">
                <th mat-header-cell *matHeaderCellDef>Test</th>
                <td mat-cell *matCellDef="let o">{{ obsTest(o) }}</td>
              </ng-container>

              <ng-container matColumnDef="result">
                <th mat-header-cell *matHeaderCellDef>Result</th>
                <td mat-cell *matCellDef="let o">
                  <app-observation-value-display [observation]="o"></app-observation-value-display>
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let o">{{ o.status ?? '—' }}</td>
              </ng-container>

              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let o">{{ obsDate(o) ? (obsDate(o) | date:'medium') : '—' }}</td>
              </ng-container>

              <ng-container matColumnDef="specimen">
                <th mat-header-cell *matHeaderCellDef>Specimen</th>
                <td mat-cell *matCellDef="let o">{{ obsSpecimen(o) }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="obsTableColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: obsTableColumns"></tr>
            </table>
          </div>
          }
        </mat-card-content>
      </mat-card>

      <mat-card class="dr-panel">
        <mat-card-subtitle>Sample handling</mat-card-subtitle>
        <mat-card-title>Specimens</mat-card-title>
        <mat-card-content>
          @if (specimens.length === 0) {
          <div class="muted">No Specimen records linked.</div>
          } @else {
          <div class="table-wrap fade-in">
            <table mat-table [dataSource]="specimens" class="mat-elevation-z0">
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let s">{{ specimenType(s) }}</td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let s">{{ s.status ?? '—' }}</td>
              </ng-container>

              <ng-container matColumnDef="collected">
                <th mat-header-cell *matHeaderCellDef>Collected</th>
                <td mat-cell *matCellDef="let s">{{ specimenCollected(s) ? (specimenCollected(s) | date:'medium') : '—'
                  }}
                </td>
              </ng-container>

              <ng-container matColumnDef="received">
                <th mat-header-cell *matHeaderCellDef>Received</th>
                <td mat-cell *matCellDef="let s">{{ specimenReceived(s) ? (specimenReceived(s) | date:'medium') : '—' }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="specimenTableColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: specimenTableColumns"></tr>
            </table>
          </div>
          }
        </mat-card-content>
      </mat-card>

      <mat-card class="dr-panel">
        <mat-card-subtitle>Imaging</mat-card-subtitle>
        <mat-card-title>Imaging studies</mat-card-title>
        <mat-card-content>
          @if (imagingStudies.length === 0) {
          <div class="muted">No ImagingStudy linked in results.</div>
          } @else {
          <div class="imaging-list">
            @for (img of imagingStudies; track img.id ?? $index) {
            <article class="imaging-item">
              <div class="imaging-item__title">{{ imagingTitle(img) }}</div>
              <div class="imaging-item__meta">
                <span>{{ imagingModalities(img) }}</span>
                <span class="dot">•</span>
                <span>{{ imagingStarted(img) ? (imagingStarted(img) | date:'medium') : '—' }}</span>
              </div>
              @if (imagingThumbs(img).length) {
              <div class="imaging-grid">
                @for (thumb of imagingThumbs(img); track thumb.url ?? thumb.title ?? $index) {
                <a class="imaging-thumb" href="{{ thumb.url || asDataUrl(thumb) || '#' }}" target="_blank" rel="noopener">
                  <img [src]="thumb.url || asDataUrl(thumb) || ''" [alt]="thumb.title ?? 'Imaging study image'" />
                  <span>{{ thumb.title ?? 'Image' }}</span>
                </a>
                }
              </div>
              }
            </article>
            }
          </div>
          }
        </mat-card-content>
      </mat-card>
    </section>

    <aside class="dr-side">
      <mat-card class="dr-panel">
        <mat-card-subtitle>Presented form</mat-card-subtitle>
        <mat-card-title>Downloadable documents</mat-card-title>
        <mat-card-content>
          @if (presentedFormAttachments(report).length === 0) {
          <div class="muted">No downloadable documents are attached in DiagnosticReport.presentedForm.</div>
          } @else {
          <div class="doc-list">
            @for (att of presentedFormAttachments(report); track att.url ?? att.title ?? $index) {
            <a class="doc-chip" href="#" (click)="downloadAttachment(att); $event.preventDefault();" rel="noopener noreferrer">
              <mat-icon aria-hidden="true">description</mat-icon>
              <span class="doc-chip__label">{{ attachmentLabel(att) }}</span>
              <small class="doc-chip__meta">{{ attachmentTypeLabel(att) }}
                @if (attachmentSizeLabel(att)) { • {{ attachmentSizeLabel(att) }} }
              </small>
            </a>
            }
          </div>
          }
        </mat-card-content>
      </mat-card>

      <mat-card class="dr-panel">
        <mat-card-subtitle>Compliance</mat-card-subtitle>
        <mat-card-title>Signatures</mat-card-title>
        <mat-card-content>
          @if (signatureLines().length === 0) {
          <div class="muted">No signatures found.</div>
          } @else {
          <div class="signatures">
            @for (s of signatureLines(); track s.type + s.who + (s.when ?? '')) {
            <div class="sig">
              <div class="sig__who">{{ s.who }}</div>
              <div class="sig__meta">
                <span>{{ s.type }}</span>
                @if (s.when) {
                <!-- <span class="dot">•</span> -->
                <span style="display:block;">{{ s.when | date:'medium' }}</span>
                }
              </div>
            </div>
            }
          </div>
          }
        </mat-card-content>
      </mat-card>
    </aside>
  </div>
  }
</div>